import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { goToPrematchedUploadPage, listOrders, listUseCases } from '../../actions/order';
import { storeWithExpiration } from '../../utils/common';
import { closeDialog } from '../../actions/dialog';
import { PROVIDER_ADMIN, PROVIDER_SALES_OPS, SUPER_ADMIN } from '../../config/app_config';
import Loading from '../shared/Loading';
import Dialog from '../shared/Dialog';

import OrdersIndex from './OrdersIndex';

export class OrdersIndexContainer extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    closeDialogAction: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    goToPrematchedUploadPageAction: PropTypes.func.isRequired,
    isProviderAdmin: PropTypes.bool.isRequired,
    isSalesOp: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    orders: PropTypes.object.isRequired,
    platformMap: PropTypes.object.isRequired,
    progress: PropTypes.number,
    listOrdersAction: PropTypes.func.isRequired,
    listUseCasesAction: PropTypes.func.isRequired,
  };

  static defaultProps = {
    progress: 1,
  };

  componentWillMount = () => {
    const { account, listOrdersAction, listUseCasesAction } = this.props;
    const token = storeWithExpiration.get('token');

    listOrdersAction(token);
    listUseCasesAction(account.id, token);
  };

  closeDialogFunction = id => {
    const { closeDialogAction } = this.props;
    closeDialogAction(id);
  };

  goToPrematchedUploadPageFunction = (orderId, dialogId) => {
    const { goToPrematchedUploadPageAction } = this.props;
    goToPrematchedUploadPageAction(orderId);
    this.closeDialogFunction(dialogId);
  };

  handleCloseDialog = id => () => {
    this.closeDialogFunction(id);
  };

  handleDialogSuccess = (recentOrderId, dialogId) => () => {
    this.goToPrematchedUploadPageFunction(recentOrderId, dialogId);
  };

  renderDialogContent = () => (
    <div>
      <p>
        You Selected that you would like to use pre-matched pair data. Would you like to upload the
        pre-matched pairs now?
      </p>
      <p>You can upload anytime through the Orders page.</p>
      <p>
        <small>
          *Note: Bulk append and full file install will not start until pre-matched files have been
          uploaded.
        </small>
      </p>
    </div>
  );

  // Creates appropriate warnings to prevent entering
  // the order form if the account is missing information
  renderNotice = (message, buttonMessage, route) => (
    <div className="alert alert-warning">
      <strong>Notice:</strong>
      <p>{message}</p>
      <p>
        <Link to={route} className="btn btn-warning">
          <i className="fa fa-plus" />
          {buttonMessage}
        </Link>
      </p>
    </div>
  );

  render() {
    const {
      account,
      dialog,
      platformMap,
      isProviderAdmin,
      isSalesOp,
      isSuperAdmin,
      orders,
      progress,
    } = this.props;
    const platformMessage =
      'Your account is not associated with any platform use cases.' +
      'You must select at least one use case before creating new orders.';
    const platformButton = 'Add Use Cases';
    const platformRoute = '/platforms';
    const recentOrderId = orders.size !== 0 ? orders.last().order.id : '';
    // Don't load Orders unless previously loaded or loading is complete
    const isLoaded = progress < 1 || (orders !== undefined && orders.size > 0);

    return isLoaded ? (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body align-items-center">
              <div className="row">
                <div className="col-sm-12">
                  <span className="pull-right">
                    {isProviderAdmin || isSalesOp ? (
                      <Link to="/orders/create/1" className="btn btn-primary" disabled>
                        New Order
                      </Link>
                    ) : null}
                  </span>
                  <h1 className="header-title">Orders</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              {platformMap.size === 0
                ? this.renderNotice(platformMessage, platformButton, platformRoute)
                : null}

              <div className="row">
                <div className="col-md-12">
                  <OrdersIndex
                    account={account}
                    minHeight={1000}
                    orders={orders}
                    isSuperAdmin={isSuperAdmin}
                  />
                </div>
              </div>

              {dialog && dialog.show && dialog.id === 'redirectToPrematchedUploadDialog' ? (
                <Dialog
                  id="redirectToPrematchedUploadDialog"
                  cancelFunction={this.handleCloseDialog(dialog.id)}
                  cancelText="Later"
                  content={this.renderDialogContent()}
                  show={dialog.show}
                  successFunction={this.handleDialogSuccess(recentOrderId, dialog.id)}
                  successText="Yes"
                  title="Upload Pre-matched Pairs"
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    ) : (
      <Loading />
    );
  }
}

function mapStateToProps(state) {
  const { account, dialog, orderList, user, progress } = state;
  const isProviderAdmin = user.get('userTypeId') === PROVIDER_ADMIN;
  const isSalesOp = user.get('userTypeId') === PROVIDER_SALES_OPS;
  const isSuperAdmin = user.get('userTypeId') === SUPER_ADMIN;
  const platformMap = orderList.get('platformMap');
  const orders = orderList.get('orders');
  return {
    account,
    dialog,
    isProviderAdmin,
    isSalesOp,
    isSuperAdmin,
    platformMap,
    progress,
    orders,
  };
}

export default connect(
  mapStateToProps,
  {
    closeDialogAction: closeDialog,
    goToPrematchedUploadPageAction: goToPrematchedUploadPage,
    listOrdersAction: listOrders,
    listUseCasesAction: listUseCases,
  }
)(OrdersIndexContainer);
